import { Heading, useAuthenticator } from '@aws-amplify/ui-react';
import { DisclaimerBar } from 'components/disclaimer';
import { HomeIntroCategories } from 'components/home-intro-categories';
import { HomeIntroPanel } from 'components/home-intro-panel';
import { useQuery } from '@apollo/client/react';
import { createSession } from 'graphql/queries';
import { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { HomeContainer } from './home.styles';

export const Home = () => {
    const { authStatus } = useAuthenticator(context => [context.authStatus]);

    if (authStatus === 'configuring') {
        return <Heading level={1}>Loading...</Heading>;
    }

    if (authStatus !== 'authenticated') {
        return null;
    }

    const { data, loading } = useQuery(createSession);

    useEffect(() => {
        if (!loading && data?.createSession) {
            localStorage.setItem('sessionID', data.createSession);
        }
    }, [loading, data]);

    return (
        <>
            <Container>
                <Row>
                    <Col style={{ padding: 0 }}>
                        <HomeContainer>
                            <HomeIntroPanel />
                        </HomeContainer>
                    </Col>
                </Row>
            </Container>
            <HomeIntroCategories />
            <DisclaimerBar />
        </>
    );
};
